import { registerNotification } from "@/shared/api/websocket"

registerNotification("trust_gate", {
	handle: () => {},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
